import { type ComponentProps, useContext } from 'react';

import { DataContext, Tooltip } from '@visx/xychart';

import './cursor.css';
import { type FormatDataPointLabel, KeyboardNavigation } from './KeyboardNavigation';

export const Cursor = <T extends object = object>({
  renderTooltip = () => '',
  formatDataPointLabel,
}: {
  renderTooltip?: ComponentProps<typeof Tooltip>['renderTooltip'];
  formatDataPointLabel: FormatDataPointLabel<T>;
}) => {
  const { theme } = useContext(DataContext) ?? {};
  const primaryColor = theme?.colors[0];

  return (
    <>
      <KeyboardNavigation<T> formatDataPointLabel={formatDataPointLabel} />
      <Tooltip
        snapTooltipToDatumX={true}
        snapTooltipToDatumY={true}
        showVerticalCrosshair={true}
        showSeriesGlyphs={true}
        renderGlyph={({ color }) => <circle r={4} fill={color} stroke="white" strokeWidth={2} />}
        verticalCrosshairStyle={{
          stroke: primaryColor,
          strokeWidth: 1,
        }}
        renderTooltip={renderTooltip}
      />
    </>
  );
};
